import { z } from "zod/v4-mini";

import { cz } from "@/utils/zodUtils";

import { TandemEventDefinition } from "../TandemTypes";

export type BolusRequested3Payload = {
  bolus_id: number;
  food_bolus_size?: number;
  correction_bolus_size?: number;
  total_bolus_size?: number;
};

export type BolusRequested3Event = {
  bolusId: number;
  foodBolusSize?: number;
  correctionBolusSize?: number;
  totalBolusSize?: number;
};

const bolusRequested3Schema = z.object({
  bolus_id: z.number(),
  food_bolus_size: cz.permissive(z.number()),
  correction_bolus_size: cz.permissive(z.number()),
  total_bolus_size: cz.permissive(z.number()),
});

export const LID_BOLUS_REQUESTED_MSG3 = {
  value: 0x42,
  name: "Bolus Requested Event 3 of 3",
  format: "h..fff",
  fields: ["bolus_id", "food_bolus_size", "correction_bolus_size", "total_bolus_size"],
  postprocess: rec => ({
    bolusId: rec.bolus_id,
    foodBolusSize: rec.food_bolus_size,
    correctionBolusSize: rec.correction_bolus_size,
    totalBolusSize: rec.total_bolus_size,
  }),
  schema: bolusRequested3Schema,
} as const satisfies TandemEventDefinition<BolusRequested3Payload, BolusRequested3Event>;
